import { render, staticRenderFns } from "./ResetPwdPage.vue?vue&type=template&id=933f6452&"
import script from "./ResetPwdPage.vue?vue&type=script&lang=js&"
export * from "./ResetPwdPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports